/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { createBrowserHistory } from 'history';

// project imports
import { sellerbaseurl, buyerbaseurl, adminbaseurl, paymentbaseurl, reportsbaseurl,alertsseurl,membershipbaseurl } from 'shared/settings/apiconfig';
import { ACCESS_TOKEN, getToken } from 'shared/settings/token';
import { logout } from 'shared/settings/auth';
import toast from 'shared/toast';
import store from 'features/store';

/* combines base url with endpoint and query params and returns complete url */
export function getSellerUrl(endPoint, params = null, isreportURL ) {
    let apiUrl = isreportURL ? reportsbaseurl + endPoint : sellerbaseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}
export function getMembermbershipUrl(endPoint, params = null, isreportURL ) {
    let apiUrl = membershipbaseurl + endPoint;

    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* combines base url with endpoint and query params and returns complete url */
export function getBuyerUrl(endPoint, params = null) {
    let apiUrl = buyerbaseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* returns http options based on params passed else returns default options */
export function getSellerHeaders(auth = true, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
    }

    if (auth) {
        headers['Authorization'] = `Bearer ${store.getState()['sellerToken']}`;
    }

    return { headers: headers };
}
export function getBuyerHeaders(token , auth = true, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
    }

    if (auth) {
        // headers['Authorization'] = `Bearer ${token}`;
        headers['Authorization'] = `Bearer ${store.getState()['buyerToken']}`;  
      }

    return { headers: headers };
}

/* combines base url with endpoint and query params and returns complete url */
export function getTaxUrl(endPoint, params = null, isTaxUrl ) {
    let apiUrl = isTaxUrl ? sellerbaseurl + endPoint : sellerbaseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* http error handler(should be called in axios catch block) */
export function errorHandler(error) {
    toast.error(error.response.data.message || '');

    // logout user when the access token becomes invalid or expired
    // TODO: use ctbids http code once implemented instead of unauthorized message
    if (error.response.data.message === 'Unauthorized : Invalid or expired token') {
        logout(createBrowserHistory());
    }
}

/* combines base url with endpoint and query params and returns complete url */
export function getAdminUrl(endPoint, params = null) {
    let apiUrl = adminbaseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

/* returns http options based on params passed else returns default options */
export function getAdminHeaders(auth = true, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
            headers['Content-Type'] = '';
    }

    if (auth) {
        headers['Authorization'] = `Bearer ${getToken(ACCESS_TOKEN)}`;
    }

    return { headers: headers };
}

export function getPaymentHeader(token, auth = true, contentType = 'json') {
    const headers = {};

    switch (contentType) {
        case 'json':
            headers['Content-Type'] = 'application/json';
            break;

        default:
    }

    if (auth) {
        headers['Authorization'] = `Bearer ${token}`;
      }

    return { headers: headers };
}

export function getPaymentUrl(endPoint, params = null) {
    let apiUrl = paymentbaseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}

export function getAlertSSEUrl(endPoint, params = null) {
    let apiUrl = alertsseurl + endPoint;

    // appends query params to the api url
    if (params && params instanceof Object && Object.keys(params).length > 0) {
        apiUrl += '?';
        Object.entries(params).forEach(([key, value]) => {
            apiUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        });
        apiUrl = apiUrl.replace(/&$/, '');
    }

    return apiUrl;
}
